export default __webpack_public_path__ + "static/media/massup_background_m2.0afbf25f.jpg";